<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-text-field
          label="Name"
          v-model="editedItem.name"
          :rules="[rules.required]"
          required
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-text-field
          label="Address line 1"
          v-model="editedItem.addressLine1"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-text-field
          label="Address line 2"
          v-model="editedItem.addressLine2"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-text-field
          label="City"
          v-model="editedItem.city"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <v-text-field
          label="Post Code"
          v-model="editedItem.postcode"
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <v-select
          :items="countries"
          label="Country"
          item-text="name"
          item-value="name"
          v-model="editedItem.country"
          filled
          return-object
        ></v-select>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import countryList from 'country-list'
import { textFieldRules } from '@/common'

export default {
  props: {
    editedItem: {
      type: Object,
      default: () => ({
        country: {
          code: 'GB',
          name: 'United Kingdom of Great Britain and Northern Ireland'
        }
      })
    },
    formValid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      valid: this.formValid,
      countries: countryList.getData(),
      rules: textFieldRules
    }
  },
  watch: {
    valid(newVal) {
      this.$emit('update:formValid', newVal)
    }
  }
}
</script>
